import { render, staticRenderFns } from "./TestResultsDetails.vue?vue&type=template&id=19d96190&scoped=true"
import script from "./TestResultsDetails.vue?vue&type=script&lang=js"
export * from "./TestResultsDetails.vue?vue&type=script&lang=js"
import style0 from "./TestResultsDetails.vue?vue&type=style&index=0&id=19d96190&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d96190",
  null
  
)

export default component.exports